export default __webpack_public_path__ + "static/media/menu_access.64a91a2e.jpg";